export const VWAP_MODE = {
  current: 0,
  average: 1,
};

export const VWAP_EXIT_CONDITION = {
  cross: 0,
  beyond: 1,
};

const VWAP_TIMEFRAME_LABELS = {
  1: "1 min",
  5: "5 min",
  15: "15 min",
  60: "1 Hour",
  240: "4 Hour",
  1440: "Daily",
};

export const VWAP_TIMEFRAME_OPTIONS = Object.entries(VWAP_TIMEFRAME_LABELS).map(
  ([value, label]) => ({
    value: Number(value),
    label,
  })
);

const hasValue = (value) => value !== undefined && value !== null && value !== "";

export const getVwapTimeframeLabel = (value) =>
  VWAP_TIMEFRAME_LABELS[value] || VWAP_TIMEFRAME_LABELS[15];

export const getVwapExitConditionLabel = (value) =>
  Number(value) === VWAP_EXIT_CONDITION.beyond
    ? "is greater than VWAP"
    : "crosses below VWAP from above";

export const formatVwapEntrySummary = (indicator) => {
  const mode = Number(
    hasValue(indicator.value2) ? indicator.value2 : indicator.value4 || VWAP_MODE.current
  );
  const boSummary = `${getVwapTimeframeLabel(indicator.value3)}`;

  if (mode === VWAP_MODE.current) {
    return `Current, ${boSummary}`;
  }

  const eoSummary = `${getVwapTimeframeLabel(indicator.value5)}`;
  const boPeriods = hasValue(indicator.period_num) ? indicator.period_num : 0;
  const eoPeriods = hasValue(indicator.value6) ? indicator.value6 : 0;

  return `Average, BO ${boSummary}, ${boPeriods} | EO ${eoSummary}, ${eoPeriods}`;
};

export const formatVwapExitSummary = (indicator) =>
  `${getVwapTimeframeLabel(indicator.value7)}, ${getVwapExitConditionLabel(
    indicator.value8
  )}`;
